import { ChangeDetectionStrategy, Component, HostBinding, Input, OnInit } from '@angular/core';
import { BadgeService } from '../badge.service';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'kgr-badge-counter',
  templateUrl: './badge-counter.component.html',
  styleUrls: ['./badge-counter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe],
})
export class BadgeCounterComponent implements OnInit {
  @HostBinding('class.kgr-badge')
  @HostBinding('class.kgr-badge--highlight')
  @HostBinding('class.kgr-hidden')
  @HostBinding('class.kgr-hidden--fadeInOnUnhidden')
  _defaultClasses = true;

  @HostBinding('class.is-unhidden') notEmpty = false;

  @Input() key!: string;

  badgeCounter$: Observable<number>;

  constructor(private badgeService: BadgeService) {}

  ngOnInit(): void {
    this.badgeCounter$ = this.badgeService.getBadgeCounter(this.key).pipe(tap((counter) => (this.notEmpty = counter > 0)));
  }
}
